import { ShoppingBag } from "lucide-react";
import type { Product } from "@/types";
import { Price } from "@/components/atoms";
import { variantPrice, subscribePrice } from "@/lib/product-helpers";
import type { BuyState } from "./product-info";

// Fixed bottom add-to-cart on small screens only (sm:hidden).
export function MobileStickyCta({
  product,
  buy,
}: {
  product: Product;
  buy: BuyState;
}) {
  const unit = buy.isSubscription
    ? subscribePrice(product, buy.variant)
    : variantPrice(product, buy.variant);
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 flex items-center justify-between gap-3 border-t border-night-blue/10 bg-white px-4 py-3 sm:hidden">
      <div className="flex flex-col">
        <span className="text-[11px] text-night-blue/70">{product.name}</span>
        <Price cents={unit} size="md" />
      </div>
      <button
        type="button"
        onClick={buy.addToCart}
        className="inline-flex h-12 flex-1 items-center justify-center gap-2 rounded-pill bg-calm-orange-ink font-condensed text-sm font-bold uppercase tracking-wide text-white active:scale-[0.98]"
      >
        <ShoppingBag size={18} /> Add to Cart
      </button>
    </div>
  );
}
